import { defineMessages } from 'react-intl';

export default {
  pages: {
    landing: {
      yourContentBanner: {
        livejasmin: {
          ...defineMessages({
            yourChoice: {
              id: 'pages.landing.yourContentBanner.livejasmin.yourChoice',
              defaultMessage: 'Your content, <b>your choice</b>',
            },
            embrace: {
              id: 'pages.landing.yourContentBanner.livejasmin.embrace',
              defaultMessage:
                'Embrace your unique style and passions and captivate your audience with whatever excites you.',
            },
          }),
        },
      },
    },
  },
};
